import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchGlAccounts = async periodName => await fetch(
  Config.endpoints.FETCH_GL_ACCOUNT_LIST
    .replace(/:periodName/, periodName)
)
  .then(handleErrors({ errorMessage: 'Fetching gl accounts failed' }))
  .then(parseAsJson);

export const importGlAccountsLists = async (GlAccountLists, periodName) => await fetch(
  Config.endpoints.ADMIN_IMPORT_GL_ACCOUNT_LIST,
  {
    method: 'POST',
    body: JSON.stringify({ GlAccountLists, periodName }),
  }
)
  .then(handleErrors({ errorMessage: 'Importing Tax Entries failed' }));


export const deleteGLAccountList = async ({ periodName, listName, glAccount }) => await fetch(
  Config.endpoints.DELETE_GL_ACCOUNT_LIST
    .replace(/:periodName/, periodName)
    .replace(/:listName/, listName)
    .replace(/:glAccount/, glAccount),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Deleting GL account List failed' }));

export const insertGLAccountList = glAccountList => fetch(
  Config.endpoints.INSERT_GL_ACCOUNT_LIST,
  {
    method: 'POST',
    body: JSON.stringify(glAccountList),
  }
)
  .then(handleErrors({ errorMessage: 'Inserting GL Account List failed' }));

export const updateGLAccountList = async ({ periodName, listName, glAccount }, glAccountList) => await fetch(
  Config.endpoints.DELETE_GL_ACCOUNT_LIST
    .replace(/:periodName/, periodName)
    .replace(/:listName/, listName)
    .replace(/:glAccount/, glAccount),
  {
    method: 'PUT',
    body: JSON.stringify(glAccountList),
  }
)
  .then(handleErrors({ errorMessage: 'Updating GL account List failed' }));
